import { Overlay } from '@/components/atoms/Overlay';
import { Fragment, useState } from 'react';
import { usePageScrollAreaHook } from '../PageScrollArea/hook/usePageScrollAreaHook';
import * as S from './styles';
import ListagemPlataformas, {
  ListagemPlataformasProps,
} from '../ListagemPlataformas';
import Button from '@/components/atoms/Button';
import useBreakpoint from '@/hooks/useBreakpoint';
import { useTheme } from 'styled-components';
import Text from '@/components/atoms/Text';
import { registrarEvento } from '@/services/googleAnalytics';

export type ModalSelecionarPlataformaProps = ListagemPlataformasProps & {
  modalVisivel: boolean;
  controlarVisibilidade: (estado: boolean) => void;
  funcaoEnviar: () => void;
};

export default function ModalSelecionarPlataforma(
  props: ModalSelecionarPlataformaProps,
) {
  const {
    modalVisivel,
    controlarVisibilidade,
    funcaoEnviar,
    $funcaoSelecionarPlataforma,
    ...rest
  } = props;

  const { retornarValorMargemTopo } = usePageScrollAreaHook({
    isPageScrollArea: false,
  });

  const { breakpoint } = useBreakpoint();
  const theme = useTheme();

  const [plataformaSelecionada, setPlataformaSelecionada] = useState('');

  if (!modalVisivel) return null;

  function fechar() {
    registrarEvento('clique_cancelar_selecionar_plataforma_resenha', {});
    controlarVisibilidade(false);
    $funcaoSelecionarPlataforma('');
    setPlataformaSelecionada('');
  }

  function selecionar(valor: string) {
    $funcaoSelecionarPlataforma(valor);
    setPlataformaSelecionada(valor);
  }

  return (
    <Fragment>
      <Overlay
        $distanciaTopo={retornarValorMargemTopo('home')}
        $valorSobreposicaoDosDemaisComponentes={995}
        onClick={fechar}
      />
      <S.Container
        style={{ minWidth: breakpoint === 'desktop' ? '610px' : '' }}
      >
        <S.ContainerSecundario>
          <div style={{ marginBottom: theme.spacing[4] }}>
            <Text
              $size={4}
              $color="neutral"
              $weight="bold"
              $align="left"
              $highContrast={true}
              $text={'Onde você assistiu?'}
            />
          </div>

          <ListagemPlataformas
            $scrollContainerHeight="60vh"
            $funcaoSelecionarPlataforma={selecionar}
            $modal
            style={{
              marginRight: theme.spacing[4],
            }}
            {...rest}
          />
          <S.Row>
            <Button
              $loading={false}
              $focusRing
              $highContrast={false}
              $color="neutral"
              $size={3}
              $text="Cancelar"
              $variant="soft"
              $onClick={fechar}
            />
            <Button
              $loading={false}
              $focusRing
              $highContrast={false}
              $color="accent"
              $size={3}
              $text="Confirmar"
              $variant="solid"
              $onClick={() => {
                controlarVisibilidade(false);
                funcaoEnviar();
              }}
              $disable={plataformaSelecionada === ''}
            />
          </S.Row>
        </S.ContainerSecundario>
      </S.Container>
    </Fragment>
  );
}
